import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchRegions as fetchRegionsApi } from '@/services/admin/client-service';
import { RegionItem, RegionState } from '@/services/types';

// ---------------------------
//  ASYNC THUNKS
// ---------------------------

export const fetchRegions = createAsyncThunk<RegionItem[]>(
  'region/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchRegionsApi();
      return data;
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  }
);

// ---------------------------
//  SLICE
// ---------------------------

const initialState: RegionState = {
  data: [],
  loading: false,
  error: null,
};

const regionSlice = createSlice({
  name: 'region',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchRegions.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchRegions.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchRegions.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
  },
});

export default regionSlice.reducer;
